import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";
import { getStatusLabelMeetingStatus } from "src/Utils/Combined";

const MeetingTableRow = ({ allMembers }: any) => {
	const theme = useTheme();
	return (
		<>
			<TableRow hover>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.member_meeting_id}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.member_meeting_title}
					</Typography>
				</TableCell>

				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{moment(allMembers.member_meeting_date).format("LL")}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{moment(allMembers.member_meeting_time, "HH:mm").format(
							"hh:mm A"
						)}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.meeting_created_by_id}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{allMembers.meeting_created_by_name}
					</Typography>
				</TableCell>
				<TableCell>
					<Typography
						variant="body1"
						color="text.primary"
						gutterBottom
						noWrap
					>
						{getStatusLabelMeetingStatus(
							allMembers.member_meeting_status
						)}
					</Typography>
				</TableCell>
				<TableCell>
					<Link
						to={`/member-list/meeting/${allMembers.member_meeting_id.toString()}`}
					>
						<Tooltip title="View" arrow>
							<IconButton
								sx={{
									"&:hover": {
										background:
											theme.colors.primary.lighter,
									},
									color: theme.palette.primary.main,
								}}
								color="inherit"
								size="small"
							>
								<VisibilityIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Link>
				</TableCell>
			</TableRow>
		</>
	);
};

export default MeetingTableRow;
